import { FaDiscord } from "react-icons/fa6";

import { Button } from "#/components/ui/button";
import { DISCORD_INVITE_URL } from "#/lib/discordInvite";
import { cn } from "#/lib/utils";

export function DiscordInviteButton({ label, className }: { label: string; className?: string }) {
  return (
    <Button
      size="sm"
      className={cn("bg-[#5865F2] text-white hover:bg-[#5865F2]/90 hover:text-white", className)}
      render={<a href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer" />}
    >
      <FaDiscord data-icon="inline-start" aria-hidden="true" />
      {label}
    </Button>
  );
}
